import React, { useState } from 'react';

import './index.scss';

function AltTextInput(props) {

  function handleAltTextInputChange(event) {

    props.onChange(event.target.value);

  }

  function renderMain() {

    const inputAttributes = {
      type: 'text',
      placeholder: 'Alt text...',
      value: props.value,
      onChange: handleAltTextInputChange
    };

    return <div className="alt-text-main">

      <input {...inputAttributes} />

    </div>;
  }

  return renderMain();
}

export default AltTextInput;